/**
 * Copy da vitrine dos Relatórios. Os números são de exemplo (rotulados "Dados de exemplo" na tela). "TMA" é o termo do
 * produto para o tempo médio de atendimento e existe nos Relatórios.
 */
export default {
    title: 'Relatórios',
    art: 'os Relatórios',
    heroTitle: ['Veja o atendimento evoluir.', 'Do começo do período até hoje.'],
    summary:
        'Satisfação, atendimentos de IA, tempo médio de atendimento (TMA) e volume ficam num painel só. O gráfico mostra de onde a equipe partiu e onde ela chegou.',
    stripLabel: 'Mede',
    strip: [
        { name: 'Satisfação', logo: null },
        { name: 'Atendimentos de IA', logo: null },
        { name: 'TMA', logo: null },
        { name: 'Volume', logo: null },
        { name: 'Primeira resposta', logo: null },
    ],
    painTitle: 'Chega sexta e ninguém sabe como foi a semana.',
    before: 'Alguém junta números de vários lugares para responder a uma pergunta simples: foi uma boa semana de atendimento?',
    after: 'Os números já estão somados num painel, e o gráfico mostra a evolução do começo do período até hoje.',
    demoTitle: 'Explore o painel.',
    demoSub: 'Escolha um indicador e passe o mouse sobre o gráfico para ver o valor de cada semana.',
    glossary: [
        { term: 'Atendimento', def: 'Uma conversa de um cliente com a equipe.', icon: 'chat' },
        { term: 'TMA', def: 'Tempo médio de atendimento: quanto uma conversa leva para ser resolvida.', icon: 'clock' },
        { term: 'Satisfação', def: 'A nota que o cliente dá ao atendimento.', icon: 'star' },
        { term: 'Atendimentos de IA', def: 'Conversas que o agente de IA conduziu.', icon: 'bot' },
    ],
    videoTitle: 'O painel em movimento.',
    poster: null,
    chapters: ['Visão geral', 'Desempenho por pessoa', 'Resumo por IA'],
    exTitle: 'Peça um resumo ao painel.',
    exSub: 'Escolha uma pergunta e veja o texto que a IA escreve a partir dos números.',
    groups: [
        { title: 'Atendimento', items: ['Satisfação (CSAT e NPS)', 'Primeira resposta e prazo (SLA)', 'Tempo médio de atendimento (TMA)', 'Volume e canais'] },
        { title: 'Inteligência artificial', items: ['Atendimentos de IA', 'Transferências para pessoas', 'Resumo escrito por IA'] },
        { title: 'Seus números', items: ['Desempenho por pessoa', 'Visão geral do período', 'Relatórios que você monta'] },
    ],
    steps: [
        { title: 'Experimente', body: 'Libere os Relatórios e abra a visão geral.' },
        { title: 'Escolha o indicador', body: 'Comece pelo número que mais importa para a sua equipe.' },
        { title: 'Monte o seu', body: 'Salve um relatório com os números que você acompanha.' },
    ],
    extraFaq: {
        q: 'Quais números aparecem?',
        a: 'Satisfação, atendimentos de IA, tempo médio de atendimento, volume, primeira resposta e prazo, além dos relatórios que você monta.',
    },
    finalTitle: 'Veja o atendimento em números.',
    finalBullets: ['Satisfação, atendimentos de IA, TMA e volume', 'Resumo escrito por IA', 'Relatórios que você monta'],
};
